import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

// Default decorative icons to aria-hidden so assistive tech doesn't read them.
// Callers that need the icon announced pass aria-label / aria-labelledby /
// role, which suppresses the default.
const SafeIcon = ({ icon, ...props }) => {
  const isLabelled = props['aria-label'] || props['aria-labelledby'] || props.role;
  const finalProps = isLabelled
    ? props
    : { 'aria-hidden': 'true', focusable: 'false', ...props };
  return React.createElement(icon || FiAlertTriangle, finalProps);
};

export default SafeIcon;
